import React from 'react'
import { Select } from 'antd'
import { languages } from 'src/core/helpers'
import { useTranslation } from 'next-i18next'
import { CustomSelect, LanguageSelectorOption } from 'src/components'

interface LanguageSelectorProps {
  name?: string
  placeholder?: string
  required?: boolean
}

const LanguageSelector: React.FC<LanguageSelectorProps> = (props) => {
  const { t } = useTranslation()
  const {
    name = 'certificateLanguage',
    placeholder = t('admin.CertificateDatePlaceholder'),
    required = true
  } = props

  return (
    <CustomSelect
      showSearch={false}
      name={name}
      placeholder={placeholder}
      required={required}
    >
      {languages.map((item, idx) => (
        <Select.Option value={item.value} key={idx}>
          <LanguageSelectorOption item={item} />
        </Select.Option>
      ))}
    </CustomSelect>
  )
}

export default LanguageSelector
